export var createArrayOfInputLabels = (inputArray, subHeadingDataFields) => {
  var labelsArray = inputArray === null || inputArray === void 0 ? void 0 : inputArray.map(item => {
    var _a;
    return {
      label: (_a = item === null || item === void 0 ? void 0 : item.fieldData) === null || _a === void 0 ? void 0 : _a.label,
      value: '',
      fieldId: item === null || item === void 0 ? void 0 : item.fieldId
    };
  }).filter(e => e.label);
  var updateLabelsArray = (subHeadingDataFields === null || subHeadingDataFields === void 0 ? void 0 : subHeadingDataFields.length) > 0 ? labelsArray.filter(item => subHeadingDataFields === null || subHeadingDataFields === void 0 ? void 0 : subHeadingDataFields.includes(item === null || item === void 0 ? void 0 : item.fieldId)) : labelsArray;
  return updateLabelsArray;
};
export var getSubHeading = _ref => {
  var data = _ref.data,
    inputLabelsRef = _ref.inputLabelsRef,
    selectedRadioLabelRef = _ref.selectedRadioLabelRef,
    prevSubHeading = _ref.prevSubHeading,
    subHeadingDataFields = _ref.subHeadingDataFields;
  var _a, _b;
  var inputLabels = inputLabelsRef.current;
  var fieldtype = data === null || data === void 0 ? void 0 : data.fieldType;
  if (!['INPUT', 'RADIO'].includes(fieldtype)) {
    return prevSubHeading;
  }
  var inputValues = inputLabelsRef.current.result;
  var selectedRadioLabel = selectedRadioLabelRef.current;
  if (fieldtype === 'INPUT') {
    inputLabels.forEach(item => {
      if (item.label === data.label) {
        item.value = (data === null || data === void 0 ? void 0 : data.value) || '';
      }
    });
    inputValues = inputLabels.map(item => !(item === null || item === void 0 ? void 0 : item.result) && (item === null || item === void 0 ? void 0 : item.value)).filter(v => v).join(' · ');
    inputLabelsRef.current.result = inputValues;
  }
  if (fieldtype === 'RADIO') {
    if ((subHeadingDataFields === null || subHeadingDataFields === void 0 ? void 0 : subHeadingDataFields.length) > 0) {
      if (subHeadingDataFields === null || subHeadingDataFields === void 0 ? void 0 : subHeadingDataFields.includes(data === null || data === void 0 ? void 0 : data.fieldId)) {
        var radioLabel = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.label;
        selectedRadioLabel = radioLabel;
        selectedRadioLabelRef.current = radioLabel;
      }
    } else {
      var _radioLabel = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.label;
      selectedRadioLabel = _radioLabel;
      selectedRadioLabelRef.current = _radioLabel;
    }
  }
  return [inputValues, selectedRadioLabel].filter(e => e).join(' · ');
};